import styled from "styled-components"
import PropTypes from "prop-types"
import LoadingSpinnerInline from "./LoadingSpinnerInline"
import React from "react"

const PaperTitle = styled.div`
  padding: 0 0.5rem;
  overflow: hidden;
  white-space: nowrap;
  flex: none;
  display: flex;
  width: 100%;
  min-height: 2.5rem;
`

export const PaperFooter = styled.div`
  padding-left: 0.5rem;
  padding-top: 1rem;
  overflow: hidden;
  white-space: nowrap;
  flex: none;
  display: flex;
  width: 100%;
  min-height: 2.5rem;
`

export const TitleTextContainer = styled.div`
  flex: auto;
  display: flex;
  align-items: center;
`
export const TitleAction = styled.div`
  cursor: pointer;
  flex: none;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  color: ${(props) => props.theme.colours.text.secondary};
  &:hover {
    color: ${(props) => props.theme.colours.active};
  }
`

const LoadingContainer = styled.span`
  padding-right: 0.5rem;
`

export const TitleText = ({ children, loadingState }) => (
  <TitleTextContainer>
    {loadingState === "loading" && (
      <LoadingContainer>
        <LoadingSpinnerInline />
      </LoadingContainer>
    )}{" "}
    {children}
  </TitleTextContainer>
)

TitleText.propTypes = {
  // The "title" content
  children: PropTypes.any,
  // A loadingState to render spinner
  loadingState: PropTypes.string,
}

export default PaperTitle
